/**
 * Demo testimonials shown when the store has no reviews yet.
 * Text is resolved via i18n keys under testimonials.placeholders.*
 */
export const testimonialsPlaceholderMeta = [
    { id: 'placeholder-testimonial-1', key: '1', rating: 5, isFeatured: true },
    { id: 'placeholder-testimonial-2', key: '2', rating: 5, isFeatured: false },
    { id: 'placeholder-testimonial-3', key: '3', rating: 5, isFeatured: false },
    { id: 'placeholder-testimonial-4', key: '4', rating: 4, isFeatured: false },
];

export function getTestimonialsPlaceholder(t) {
    return testimonialsPlaceholderMeta.map((item) => ({
        id: item.id,
        name: t(`testimonials.placeholders.${item.key}.name`),
        role: t(`testimonials.placeholders.${item.key}.role`),
        message: t(`testimonials.placeholders.${item.key}.message`),
        avatarUrl: '',
        rating: item.rating,
        isFeatured: item.isFeatured,
    }));
}
